const DEFAULT_MAX_SIZE = 20;

/**
 * Adds a leader key to the front of the LRU list.
 * Removes duplicates and bounds the result to maxSize.
 */
export function addLeader(list: string[], key: string, maxSize = DEFAULT_MAX_SIZE): string[] {
  return [key, ...list.filter((k) => k !== key)].slice(0, maxSize);
}

/**
 * Returns the first key from the LRU list that appears in candidates, or undefined.
 */
export function findLeader(list: string[], candidates: string[]): string | undefined {
  const set = new Set(candidates);
  return list.find((k) => set.has(k));
}
